import React from 'react';

import { PageWithSidebar } from '@vlabs/uikit';

import { SelectedEventEmptyState } from './SelectedEventEmptyState';
import { DetectionAndMatchEventView } from '../detection-and-match-event/DetectionAndMatchEventView';
import {
  EVENT_ROLL_SIDEBARS as SIDEBARS,
} from '../event-roll/EventRoll.js';
import type { SidebarName } from '../event-roll/EventRoll.js';
import WorkspaceFiltersPanel from '../filters/WorkspaceFiltersPanel';
import WorkspaceSettingsPanel from '../settings/WorkspaceSettingsPanel';
import { useSelectedWorkspaceEvent } from '../useSelectedWorkspaceEvent.js';
import { VideoAnalyticsEventView } from '../video-analytics-event/VideoAnalyticsEventView';

interface SelectedEventViewProps {
  activeSidebar: SidebarName | null;
  onToggleSidebar: (name: SidebarName) => void;
}

export function SelectedEventView({
  activeSidebar,
  onToggleSidebar,
}: SelectedEventViewProps): React.JSX.Element {
  const { isGeneralEvent, isEvent, selectedEventId } = useSelectedWorkspaceEvent();

  return (
    <PageWithSidebar
      isOpenLeftSidebar={!!activeSidebar}
      leftSidebar={(
        <React.Fragment>
          {activeSidebar === SIDEBARS.FILTERS && (
            <WorkspaceFiltersPanel
              key="filters"
              onCloseClick={() => onToggleSidebar('filters')}
            />
          )}
          {activeSidebar === SIDEBARS.SETTINGS && (
            <WorkspaceSettingsPanel
              key="settings"
              onCloseClick={() => onToggleSidebar('settings')}
            />
          )}
        </React.Fragment>
      )}
      mode="overlay"
    >
      {!!isEvent && !!selectedEventId && <DetectionAndMatchEventView />}
      {!!isGeneralEvent && !!selectedEventId && <VideoAnalyticsEventView />}

      {!selectedEventId && <SelectedEventEmptyState />}
    </PageWithSidebar>
  );
}
